import React from 'react'
import _ from 'lodash'
import getSymbolFromCurrency from 'currency-symbol-map'
import './styles.css'

class PlanBox extends React.Component {
	render(){
		const { plan } = this.props;
		const planDetails = plan.planDetails[0];
		return (
			<div className="planbox site-background-color" onClick={ _ => this.props.onClick() }>
				<div className="planbox__header">
					<div className="planbox__header__value__container">
						{ (planDetails.displayStrikeThroughPrice && planDetails.strikeThroughPrice) ? <div className="planbox__header__strike-through">{ getSymbolFromCurrency(planDetails.recurringPaymentCurrencyCode) }{ planDetails.strikeThroughPrice  } </div> : ''}
						<div className="planbox__header__value"><span className="price"> { getSymbolFromCurrency(planDetails.recurringPaymentCurrencyCode) }{ planDetails.recurringPaymentAmount } *</span></div>
					</div>
					<div className="planbox__header__cycle"> { plan.name }</div>
				</div>
				<div className="planbox__details">
					{plan.description}
				</div>
			</div>
		)
	}

}

export default PlanBox